module.exports = __webpack_public_path__ + "static/media/sorting-arrow-down.c3f0a1d0.svg";